export default "__VITE_ASSET__cc7b65ba__"